import { render, staticRenderFns } from "./DataTransfer.vue?vue&type=template&id=3b458ccc&scoped=true"
import script from "./DataTransfer.vue?vue&type=script&lang=js"
export * from "./DataTransfer.vue?vue&type=script&lang=js"
import style0 from "./DataTransfer.vue?vue&type=style&index=0&id=3b458ccc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b458ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b458ccc')) {
      api.createRecord('3b458ccc', component.options)
    } else {
      api.reload('3b458ccc', component.options)
    }
    module.hot.accept("./DataTransfer.vue?vue&type=template&id=3b458ccc&scoped=true", function () {
      api.rerender('3b458ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TradeWatcher/DataTransfer.vue"
export default component.exports